import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useFindOneRmaQuery, useUpdateRmaMutation } from "../../api/api-hooks";

interface Props {
  confirmDialogOpen: boolean;
  setConfirmDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  clickedRma: string | number;
}
const LptRmaCompleteConfirmationDialog = ({
  confirmDialogOpen,
  setConfirmDialogOpen,
  clickedRma,
}: Props) => {
  const [updateRma] = useUpdateRmaMutation();
  const { data: selectedRma } = useFindOneRmaQuery({ id: Number(clickedRma) });
  if (selectedRma === undefined) return null;
  const handleConfirm = () => {
    updateRma({
      id: Number(clickedRma),
      updateRmaDto: {
        id: Number(clickedRma),
        isComplete: true,
      },
    });
    setConfirmDialogOpen(false);
  };
  const handleCancel = () => {
    setConfirmDialogOpen(false);
  };
  return (
    <Dialog
      fullWidth
      open={confirmDialogOpen}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>Mark RMA as Complete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to mark this RMA as complete?
        </Typography>
        {selectedRma.status !== "Closed" && (
          <Typography color="error">
            The RMA is not currently marked 'Closed'.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          Confirm
        </Button>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LptRmaCompleteConfirmationDialog;
